<template>
  <div v-if="['/mobile'].includes(route.path)">
    <router-view />
  </div>
  <div
    v-else
    class="all-container"
    :class="!isQianKun && 'padding-t-70'"
    v-if="flag"
    @scroll="scroll"
  >
    <el-config-provider :locale="localeEl">
      <a-config-provider :locale="locale" :autoInsertSpaceInButton="false">
        <header-view
          v-if="
            !['/preview', '/translate', '/mobile'].includes(route.path) &&
            !isQianKun
          "
          :scrollTop="scrollTop"
        ></header-view>
        <div class="containerBox">
          <router-view />
        </div>
        <footer-view
          v-if="
            ![
              '/preview',
              '/translate',
              '/experiencePreview',
              '/mobile',
            ].includes(route.path) && !isQianKun
          "
        ></footer-view>

        <!--不要改这里，里面有组件涉及权限校验-->
        <div
          v-if="
            isQianKun &&
            !['/preview', '/translate', '/mobile'].includes(route.path)
          "
          style="display: none"
        >
          <header-view></header-view>
        </div>
      </a-config-provider>
    </el-config-provider>
  </div>
  <div class="home-help" v-if="isShow">
    <a-popover
      placement="left"
      trigger="click"
      overlayClassName="home-help-popover"
    >
      <template #content>
        <div>
          <img
            src="https://ali-file-cdn.iol8.com/img/img/pe-kf-400-400.png"
            style="width: 120px"
          />
        </div>
      </template>
      <template #title>
        <span></span>
      </template>
      <div class="item">
        <div>
          <svg>
            <use xlink:href="#icon-kefu"></use>
          </svg>
        </div>
        <div>在线客服</div>
      </div>
    </a-popover>
    <!-- <div class="item" @click="openCooperateModal">
      <div>
        <svg>
          <use xlink:href="#icon-hezuo"></use>
        </svg>
      </div>
      <div>合作咨询</div>
    </div> -->
  </div>
  <a-modal
    v-model:visible="visible"
    title="合作咨询"
    @ok="handleOk"
    centered
    wrapClassName="cooperateModal"
    v-if="visible"
  >
    <div>
      <a-form labelAlign="left" ref="formRef" :model="formState" :rules="rules">
        <a-form-item ref="name" label="姓名" name="name">
          <a-input
            v-model:value="formState.name"
            placeholder="请输入联系人姓名"
            autocomplete="off"
          />
        </a-form-item>
        <a-form-item ref="telPhone" label="手机" name="telPhone">
          <a-input
            v-model:value="formState.telPhone"
            placeholder="请输入联系人手机"
            autocomplete="off"
          />
        </a-form-item>
        <a-form-item ref="company" label="公司" name="company">
          <a-input
            v-model:value="formState.company"
            placeholder="请输入公司名称"
            autocomplete="off"
          />
        </a-form-item>
        <a-form-item ref="des" label="需求简述" name="des">
          <a-textarea
            :auto-size="{ minRows: 3, maxRows: 5 }"
            v-model:value="formState.des"
            placeholder="您希望了解什么内容？TwinsMT可以帮助你训练属于你自己的引擎，您也可以将平台训练好的引擎通过API接入使用。"
          />
        </a-form-item>
      </a-form>
    </div>
  </a-modal>
</template>

<script>
  import {
    watch,
    nextTick,
    ref,
    reactive,
    toRefs,
    computed,
    onMounted,
  } from 'vue'
  import { provide } from 'vue'
  import { useStore } from 'vuex'
  import { useRoute, useRouter } from 'vue-router'
  import mitt from '@/mitt/mitt.js'
  import * as echarts from 'echarts'
  import zhCn from 'element-plus/lib/locale/lang/zh-cn'
  import zhCN from 'ant-design-vue/es/locale/zh_CN'

  import HeaderView from '@/components/Header/Header.vue'
  import FooterView from '@/components/Footer/Footer.vue'
  import EngineOnline from '@/components/Modal/EngineOnline.vue'
  import useUtils from '@/utils/useUtils'
  import { checkLoginApi, getEnterpriseJoinList } from '@/http/api'

  export default {
    components: {
      HeaderView,
      FooterView,
      EngineOnline,
    },
    setup() {
      const route = useRoute()
      const router = useRouter()
      const store = useStore()
      const flag = ref(true)
      const timeout = ref(null)
      const isQianKun = window.__POWERED_BY_QIANKUN__

      const enterpriseGlobalId = computed(
        () => store.state.comm.enterpriseGlobalId
      )

      if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        router.push({
          path: '/mobile',
        })
      }

      const { msgUpdate } = useUtils()

      provide('echarts', echarts)

      const isShow = computed(() => {
        const flag =
          route.fullPath.includes('home') ||
          route.fullPath.includes('create') ||
          route.fullPath.includes('subData')
        return flag
      })

      const state = reactive({
        visible: false,
        oldScript: [],
        newScript: [],
      })

      const rules = {
        name: [
          { required: true, message: '请填写正确的姓名', trigger: 'blur' },
          { min: 2, max: 10, message: '请填写正确的姓名', trigger: 'blur' },
        ],
        telPhone: [
          { required: true, message: '请填写正确的手机号', trigger: 'blur' },
          { min: 11, max: 11, message: '请填写正确的手机号', trigger: 'blur' },
        ],
        company: [
          { required: true, message: '请填写正确的公司', trigger: 'blur' },
          { min: 2, max: 50, message: '请填写正确的公司', trigger: 'blur' },
        ],
        des: [
          {
            required: true,
            message:
              '请填写大于10个小于400个字的描述，让我们更清楚的知道您需要什么',
            trigger: 'blur',
          },
          {
            min: 10,
            max: 400,
            message:
              '请填写大于10个小于400个字的描述，让我们更清楚的知道您需要什么',
            trigger: 'blur',
          },
        ],
      }

      const formState = reactive({
        name: '',
        telPhone: '',
        company: '',
        des: '',
      })

      const scrollTop = ref(0)

      const scroll = (ev) => {
        const top = ev.target.scrollTop
        scrollTop.value = top
        mitt.emit('bodyScroll', ev)
      }

      const openCooperateModal = () => {
        state.visible = true
      }

      const handleOk = () => {
        formRef.value.validateFields().then((res) => {
          let params = {
            name: formState.name,
            phone: formState.telPhone,
            company: formState.company,
            description: formState.des,
          }
          postConsultationSeek(params).then((res) => {
            message.success('发送成功')
            state.visible = false
          })
        })
      }

      const onSubmit = () => {
        formRef.value
          .validate()
          .then(() => {
            console.log('values', formState, toRaw(formState))
          })
          .catch((error) => {
            console.log('error', error)
          })
      }

      const resetForm = () => {
        formRef.value.resetFields()
      }

      // 获取当前html
      const getHtml = async () => {
        const html = await fetch('/?t=' + new Date().getTime()).then((res) =>
          res.text()
        ) // 读取index html
        return html
      }

      // 匹配script
      const parserScript = (html) => {
        const reg = new RegExp(/<script(?:\s+[^>]*)?>(.*?)<\/script\s*>/gi) // script正则
        return html.match(reg) // 匹配script标签
      }

      // 浏览器html同服务器html进行对比
      const compareFunc = (oldArr, newArr) => {
        const base = oldArr.length
        const arr = Array.from(new Set(oldArr.concat(newArr)))
        // 如果新旧length 一样无更新
        if (arr.length === base) {
          // 无更新
        } else {
          // 更新了
          msgUpdate('新版本更新，请务必刷新页面', '立即刷新')
        }
      }

      // 初始化浏览器html
      const scriptInitFunc = async () => {
        const html = await getHtml()
        state.oldScript = parserScript(html)
      }

      const getURLParameter = (url, parameter) => {
        // let pattern = new RegExp('([?|&])' + parameter + '=([^&]*)');
        // var matches = url.match(pattern);
        // return matches ? decodeURIComponent(matches[2]) : null;
      }

      onMounted(() => {
        scriptInitFunc()

        checkLoginApi().then((res) => {
          if (res.data.data) {
            store.dispatch('user/checkToken')
          }
        })

        store.dispatch('user/getDictionary')

        if (localStorage.token) {
          store.dispatch('user/checkToken').then(async () => {
            timeout.value = setInterval(async () => {
              const newHtml = await getHtml()
              state.newScript = parserScript(newHtml)
              compareFunc(state.oldScript, state.newScript)
            }, 60000)
          })
        }
      })

      watch(
        () => enterpriseGlobalId.value,
        (n) => {
          if (n) {
            flag.value = false
            store.dispatch('comm/getEnterpriseSettingsFunc')
            nextTick(() => {
              flag.value = true
            })
          }
        }
      )

      return {
        ...toRefs(state),
        isQianKun,
        formState,
        flag,
        localeEl: zhCn,
        locale: zhCN,
        route,
        rules,
        scrollTop,
        isShow,
        scroll,
        openCooperateModal,
        handleOk,
        onSubmit,
        resetForm,
      }
    },
  }
</script>

<style lang="scss">
  .all-container {
    height: 100vh;
    overflow-y: auto;
    background-color: #f9faff;
    &::-webkit-input-placeholder {
      font-size: 14px;
      color: #818385;
    }
    &::-webkit-scrollbar {
      width: 7px;
      background-color: rgba(0, 0, 0, 0);
    }
    &::-webkit-scrollbar-thumb {
      background: #bfbfbf;
      border-radius: 10px;
      width: 7px;
    }
  }
  .home-help {
    position: fixed;
    top: 50%;
    right: 0;
    transform: translate(0, -50%);
    background: white;
    width: 72px;
    border-radius: 8px 0px 0px 8px;
    box-shadow: 0px 4px 12px 0px rgba(122, 89, 255, 0.2);
    svg {
      width: 22px;
      height: 22px;
      margin-bottom: 2px;
    }
    .item {
      height: 72px;
      padding: 12px 0;
      font-size: 12px;
      color: #333;
      text-align: center;
      cursor: pointer;
    }
    .item:nth-child(1) {
      border-bottom: 1px #eeeeee solid;
    }
  }
  #app {
    // font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #333;
  }
  .containerBox {
    min-height: calc(100vh - 126px);
    background-color: #f9faff;
  }
</style>
